module.exports = __webpack_public_path__ + "img/cc_ylands_footer_join-eb.59442ffb.png";